module.exports = {uri: __webpack_public_path__ + "img/back-icon.png", width: 96, height: 96};